import { flexRender, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import React from 'react'
import { FaEdit, FaTimes } from 'react-icons/fa';

const SitesTable = ({
    sites,
    onDelete,
    onEdit
}) => {
    const columns = React.useMemo(
        () => [
            {
                header: 'Client',
                accessorKey: 'client.name'
            },
            {
                header: 'Name',
                accessorKey: 'name',
            },
            {
                header: 'Supervisor',
                accessorKey: 'supervisor.name'
            },
            {
                header: 'Longitude',
                accessorKey: 'longitude',
            },
            {
                header: 'Latitude',
                accessorKey: 'latitude',
            },
            {
                header: 'Geofence Radius(m)',
                accessorKey: 'geo_fence_radius',
            },
            {
                header: 'Created By',
                accessorKey: 'user.name',
            },
            {
                header: 'Date Created',
                accessorKey: 'created_at',
            },
            {
                header: 'Date updated',
                accessorKey: 'updated_at',
            },
            {
                header: 'Actions',
                id: 'actions',
                cell: ({row}) => (
                    <>
                        <FaTimes 
                            className='fa-times'
                            data-toggle='tooltip'
                            title='Delete'
                            data-placement='bottom'
                            onClick={() => onDelete(row.original.id)}
                        />

                        <FaEdit
                            className='fa-edit'
                            title='Edit'
                            data-placement='bottom'
                            onClick={() => onEdit(row.original.id)}
                            data-toggle='tooltip'
                        />
                    
                    </>
                )
            }
        ],
        [onDelete, onEdit]
    );

    const table = useReactTable({
        data: sites,
        columns,
        getCoreRowModel: getCoreRowModel()
    });

    if (sites.length === 0) {
        return <div className="text-center">No sites found</div>
    }
  return (
    <table className='table table-striped'>
        <thead>
        {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
            {headerGroup.headers.map((header) => (
                <th key={header.id}>{header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}</th>
            ))}
            </tr>
        ))}
        </thead>
        <tbody>
        {table.getRowModel().rows.map((row) => (
            <tr key={row.id}>
            {row.getVisibleCells().map((cell) => (
                <td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
            ))}
            </tr>
        ))}
        </tbody>
    </table>
  )
}

export default SitesTable